/**
 * Conifguration related to the enterprise partner
 */

export const HIGHLIGHT_KEY = process.env.REACT_APP_HIGHLIGHT_KEY || 'k4g8w9g5';
